import React from "react";
import img1 from "../.././assets/All/404img.png";

const NotFound = () => {
  return (
    <div>
      <img className="mx-auto" src={img1} alt="" />
    </div>
  );
};

export default NotFound;
